import useMutation from "src/hooks/useMutation";

function useUpdateBulkReturnProcessing(id) {
  return useMutation({
    path: `/api/v1/return-logs/${id}`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/return-logs/${id}`,
      shouldRevalidate: true,
    },
  });
}

export default useUpdateBulkReturnProcessing;
